import { belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import type DeviceOrderedJournalEvent from "parog-web/models/device-ordered-journal-event";
import JournalEvent from "parog-web/models/journal-event";
import tWithDefault from "parog-web/utils/t-with-default";

//---- Automatically generated, don't update this part ----

/**
 * Created if our team refuse the order of a Withings tensiometer
 */
export default class DeviceOrderRefusedJournalEvent extends JournalEvent {
  static override type = "device-order-refused-journal-event";

  @belongsTo("device-ordered-journal-event", {
    async: false,
    inverse: "deviceOrderRefusedJournalEvent"
  })
  declare deviceOrderedJournalEvent: DeviceOrderedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      deviceOrderedJournalEvent: validatePresence({
        presence: true,
        description: intl.t(
          "validations.device-order-refused-journal-event.device-ordered-journal-event"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.device-order-refused-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "device-order-refused-journal-event": DeviceOrderRefusedJournalEvent;
  }
}
